// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentProps, useContext } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { updateMe } from '../apis/member';
import { uploadFile } from '../apis/base';
import CameraHoverImageSrc from '../assets/images/camera-hover.svg';
import CameraImageSrc from '../assets/images/camera.svg';
import CoverImageSrc from '../assets/images/member-layout-banner.png';
import Center from '../components/Center';
import Circle from '../components/Circle';
import Column from '../components/Column';
import CoverImage from '../components/CoverImage';
import Icon from '../components/Icon';
import Row from '../components/Row';
import HugeTitle from '../components/typography/HugeTitle';
import Text from '../components/typography/Text';
import MemberContext from '../contexts/MemberContext';

const CameraImg = styled(Icon)``;

const Sidebar = styled(Column)`
  width: 245px;
`;

const Content = styled.div`
  margin-top: 58px;
  flex: 1 0 auto;
`;

const MenuList = styled(Column)`
  align-self: stretch;
`;

const Line = styled.div`
  height: 1px;
  width: 65px;
  background: #ef8200;
  opacity: 0;
`;

const MemberAvatar = styled<ComponentProps<any>>(Circle).attrs({
  as: Center,
  backgroundColor: 'Orange'
})`
  position: relative;
  width: 108px;
  min-height: 108px;
  background-image: url(${({ imageUrl }: any) => imageUrl});
  background-position: center;
  background-size: cover;
`;

const BorderCircle = styled(Circle)`
  border-width: 1px;
  border-style: solid;
  opacity: 0;
`;

interface MenuItemProps {
  active?: boolean;
  to: string;
}

const MenuItem = styled(
  ({ className, to, children }: MenuItemProps & React.ComponentProps<any>) => {
    return (
      <Link className={className} to={to}>
        <Row alignY="center">
          <Line />
          <BorderCircle size={5} borderColor="Orange" />
          <Text style={{ marginLeft: '13px' }}>{children}</Text>
        </Row>
      </Link>
    );
  }
)`
  &:hover {
    ${Line}, ${BorderCircle} {
      opacity: 1;
    }

    ${Text} {
      color: #ef8200;
    }
  }

  ${({ active }) =>
    active
      ? `
    ${Line}, ${BorderCircle} {
      opacity: 1;
    }

    ${Text} {
      color: #EF8200;
    }`
      : ''}
`;

const FileLabelWrapper = styled.div`
  display: inline-flex;
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;
  border-radius: 100%;
`;

const FileLabel = styled.label`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  cursor: pointer;
`;

const FileInput = styled.input.attrs({ type: 'file' })`
  opacity: 0;
  display: none;
`;

export default function ({ children, style }: React.ComponentProps<'div'>) {
  const member = useContext(MemberContext);
  const memberMatch = useRouteMatch('/member');
  const notificationsMatch = useRouteMatch('/notifications');
  // const pointsMatch = useRouteMatch('/points');
  // const ordersMatch = useRouteMatch('/orders');

  async function uploadImage(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e?.target?.files?.[0];
    if (file) {
      console.log('uploadImage', file);
      const { fileName, upload } = await uploadFile(file);
      console.log({ fileName, upload });
      upload.then(async () => {
        await updateMe({
          imageUrl: fileName
        });
        member.update && member.update()
      });
    }
  }

  return (
    <Column style={style}>
      <CoverImage src={CoverImageSrc} height="232px" />
      <Row alignX="center" style={{ maxWidth: '1440px' }}>
        <Sidebar alignX="center" style={{ margin: '58px 0px' }}>
          <MemberAvatar imageUrl={member.imageUrl}>
            {
              !member.imageUrl
                ? <HugeTitle style={{ textTransform: 'uppercase', fontFamily: 'Noto Sans TC', fontStyle: 'normal', color: '#FFFFFF' }}>{member.firstName ? member.email[0] : ''}</HugeTitle>
                : null
            }
            <FileLabelWrapper>
              <CameraImg
                icon={CameraImageSrc}
                hoverIcon={CameraHoverImageSrc}
              />
              <FileLabel htmlFor="file">
                <FileInput id="file" onChange={uploadImage} />
              </FileLabel>
            </FileLabelWrapper>
          </MemberAvatar>
          <Text style={{ marginTop: '41px' }}>{member.username}</Text>
          <MenuList gap={30} style={{ marginTop: '36px' }}>
            <MenuItem active={memberMatch} to="/member">
              基本設定
            </MenuItem>
            {
              // <MenuItem active={pointsMatch} to="/points">
              //   我的積分
              // </MenuItem>
            }
            {/* <MenuItem active={ordersMatch} to="/orders">
              訂單記錄
            </MenuItem> */}
          </MenuList>
        </Sidebar>
        <Content>{children}</Content>
      </Row>
    </Column>
  );
}
